import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
// import MobileLiveScreen from "./mobile/MobileLiveScreen";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
// import TabletLiveScreen from "./tablet/TabletLiveScreen";
import OrderLiveScreen from "./OrderLiveScreen";
import StockLiveScreen from "./StockLiveScreen";
import CommentLiveScreen from "./CommentLiveScreen";
import { 
    // Breadcrumb, 
    Button, Spinner } from "react-bootstrap";
import { CANCELLED, COLOR_APP } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faVideoSlash, faVolumeHigh, faVolumeMute } from "@fortawesome/free-solid-svg-icons";
import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import { GET_ORDERS } from "../../../graphql/order/query";
import { useApolloClient, useLazyQuery, useMutation, useSubscription } from "@apollo/client";
import { SUBSCRIPTION_ORDER } from "../../../graphql/order/subscription";
// import { thousandSeperate } from "../../../helpers";
import { GET_LIVE } from "../../../graphql/live/query";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import { END_LIVE, SUBSCRIBE_LIVE, UNSUBSCRIBE_LIVE } from "../../../graphql/liveManage/subscribeLive";
import { CREATE_SETTING, UPDATE_SETTING } from "../../../graphql/setting/mutation";
import { useToasts } from "react-toast-notifications";
// import { EmbeddedPost, EmbeddedVideo, FacebookProvider } from "react-facebook";
import Switch from "react-switch";
// import FacebookVideo from "./FacebookVideo";
import { useLocation } from 'react-router-dom';

// style
function LiveScreen() {
    const { addToast } = useToasts()
    const { height, width } = useWindowDimensions();
    const { history, match } = useReactRouter()
    const location = useLocation();

    // const { data: sendMessageData } = useSubscription(SUBSCRIPTION_ORDER, {
    //     variables: {
    //         liveId: match.params?.liveId
    //     }
    // });

    const client = useApolloClient();
    const { data: sendMessageData, error, loading, subscribeToMore } = useSubscription(SUBSCRIPTION_ORDER, {
        variables: {
            liveId: match.params?.liveId
        },
        onError: (error) => {
            console.error('Subscription error:', error);
            // Attempt to resubscribe
            subscribeAgain();
        }
    });

    // const [subscribeLive] = useMutation(SUBSCRIBE_LIVE);
    const [createSetting] = useMutation(CREATE_SETTING)
    const [updateSetting] = useMutation(UPDATE_SETTING)
    const [endLiveVDO, { loading: endLiveLoading }] = useMutation(END_LIVE);
    const [unsubscribeLive] = useMutation(UNSUBSCRIBE_LIVE);

    const [getLiveStocks, { data: liveStockDatas }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
    // const [getLiveStocks, { data: liveStockDatas }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
    const [getLiveOrders, { data: orderDatas, loading: loadingOrders }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    const [getLive, { data: liveData }] = useLazyQuery(GET_LIVE, { fetchPolicy: "cache-and-network" });
    const [getSettings, { data: shopSettingData, loadding: isLoadSetting }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });

    // State
    const [liveStocks, setLiveStocks] = useState([]);
    const [totalLiveStock, seTotalLiveStock] = useState(0);
    const [orders, setOrders] = useState([]);
    const [createResp,setCreateResp] = useState()
    const [totalOrder, setTotalOrder] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const [playNoProduct, setPlayNoProduct] = useState(false);
    const [shopSettings, setShopSettings] = useState();
    const [shopSettingLive, setShopSettingLive] = useState();
    // const [limit, setLimit] = useState(20);
    // const [skip, setSkip] = useState(1);

    const subscribeAgain = () => {
        // Optionally check if the network status is online before resubscribing
        subscribeToMore({
            document: SUBSCRIPTION_ORDER,
            variables: { liveId: match.params?.liveId },
            updateQuery: (prev, { subscriptionData }) => {
                if (!subscriptionData.data) return prev;
                return subscriptionData.data;
            },
        });
    };

    // useEffect 
    useEffect(() => {
        initSetting();

        const goOnline = () => {
            if (navigator.onLine) {
                subscribeAgain();
            }
        };

        window.addEventListener('online', goOnline);
        return () => {
            window.removeEventListener('online', goOnline);
        };
    }, []);

    useEffect(() => {
        if (match.params?.liveId) {
            fetchLiveStocks(0, 10000);
            fetchLiveOrders();
        }
    }, [match.params?.liveId])

    useEffect(() => {
        if (sendMessageData?.onOrderCreated?.id) {
            updateOrder(sendMessageData?.onOrderCreated);
            updateLiveStock(sendMessageData?.onOrderCreated?.liveStock?.id, sendMessageData?.onOrderCreated?.amount);
        }
    }, [sendMessageData])

    useEffect(() => {
        if (liveStockDatas?.liveStocks) {
            const _newLiveStocks = [...liveStockDatas?.liveStocks?.data];
            setLiveStocks(_newLiveStocks);
            // setLiveStocks(liveStockDatas?.liveStocks?.data);
            seTotalLiveStock(liveStockDatas?.liveStocks?.total);
        }
    }, [liveStockDatas?.liveStocks])

    useEffect(() => {
        if (match.params?.liveId) fetchLive()
    }, [match.params?.liveId])

    useEffect(() => {
        if (orderDatas?.orders) {
            setOrders(orderDatas?.orders?.data);
            setTotalOrder(orderDatas?.orders?.total);
        }
    }, [orderDatas])

    useEffect(() => {
        if (shopSettingData?.settings?.data?.length > 0) {
            setShopSettings(shopSettingData?.settings?.data[0])
            if (shopSettingData?.settings?.data[0]?.live) {
                let _liveSetting = JSON.parse(shopSettingData?.settings?.data[0]?.live)
                setShopSettingLive(_liveSetting)
                if (_liveSetting?.playNoProduct === "false") setPlayNoProduct(false)
            }
        }
    }, [shopSettingData])

    const updateOrder = (newOrder) => {
        setTotalOrder(parseInt(totalOrder) + 1);
        const _newOrder = [newOrder, ...orders];
        setOrders(_newOrder)
    }
    const updateOrderV2 = (newOrder) => {
        const timeoutId = setTimeout(() => {
            const _newOrder = [...newOrder, ...orders];
            setOrders(_newOrder);
        }, 4000);
    
        return () => clearTimeout(timeoutId);
    }

    const updateLiveStock = (liveStockId, amount) => {
        const _lSIndex = _.findIndex(liveStocks, { id: liveStockId }); // Find the index of the object 
        if (_lSIndex < 0) return;

        // const updatedArray = _.cloneDeep(liveStocks); // Make a deep copy of the original array
        // updatedArray[_lSIndex] = { ...updatedArray[_lSIndex], amount: parseInt(updatedArray[_lSIndex]?.amount) - parseInt(amount) };

        const _updateLiveStocks = liveStocks?.map((_liveStock) => {
            if (_liveStock?.id === liveStockId) return { ..._liveStock, amount: parseInt(_liveStock?.amount) - parseInt(amount) }
            return _liveStock
        })
        setLiveStocks(_updateLiveStocks);
    }

    const restoreAmountAndCancelOrder = (orderId, liveStockId, amount, isCancelled) => {
        // Cancel Order
        setTotalOrder(parseInt(totalOrder) - 1);
        const _oIndex = _.findIndex(orders, { id: orderId }); // Find the index of the object 
        if (_oIndex < 0) return;

        const updatedOrder = _.cloneDeep(orders); // Make a deep copy of the original array
        updatedOrder[_oIndex] = { ...updatedOrder[_oIndex], status: CANCELLED, isCancelled: isCancelled || true };
        setOrders(updatedOrder);

        // Restore amount
        const _lSIndex = _.findIndex(liveStocks, { id: liveStockId }); // Find the index of the object 
        if (_lSIndex < 0) return;

        const updatedLiveStock = _.cloneDeep(liveStocks); // Make a deep copy of the original array
        updatedLiveStock[_lSIndex] = { ...updatedLiveStock[_lSIndex], amount: parseInt(updatedLiveStock[_lSIndex]?.amount) + parseInt(amount) };
        setLiveStocks(updatedLiveStock);
    }

    const fetchLiveStocks = async (_skip, _limit) => {
        try {
            const liveId = match.params?.liveId;
            await getLiveStocks({
                variables: {
                    where: {
                        live: liveId
                    },
                    skip: _skip,
                    limit: 10000,
                    orderBy: "createdAt_DESC"
                }
            })
        } catch (error) {
            console.log("Error retrieving _liveOrder", error);
        }
    }

    const fetchLiveOrders = async () => {
        try {
            const liveId = match.params?.liveId;
            await getLiveOrders({
                variables: {
                    where: {
                        live: liveId
                    },
                    skip: 0,
                    limit: 1000,
                    orderBy: "createdAt_DESC"
                }
            })
        } catch (error) {
            console.log("Error retrieving _liveOrder", error);
        }
    }

    const onPlayNoProduct = async (e) => {
        try {
            // const SHOP_ID = await localStorage.getItem("SHOP");
            // if (!shopSettings) {
            //     createSetting({
            //         variables: {
            //             data: {
            //                 live: JSON.stringify({
            //                     symbol: "=",
            //                     limit: 1,
            //                     playNoProduct: (!playNoProduct).toString()
            //                 }),
            //                 shop: SHOP_ID
            //             }
            //         }
            //     })
            //     addToast("ຕັ້ງຄ່າສຽງສໍາເລັດ", { appearance: 'success', autoDismiss: true })
            // } else {
            //     updateSetting({
            //         variables: {
            //             where: { id: shopSettings.id },
            //             data: {
            //                 live: JSON.stringify({
            //                     ...shopSettingLive,
            //                     playNoProduct: (!playNoProduct).toString()
            //                 }),
            //             }
            //         }
            //     })
            //     addToast("ຕັ້ງຄ່າສຽງສໍາເລັດ", { appearance: 'success', autoDismiss: true })
            // }
            addToast("ຕັ້ງຄ່າສຽງສໍາເລັດ", { appearance: 'success', autoDismiss: true })
            setPlayNoProduct(!playNoProduct)
        } catch (error) {
            console.log(error);
            addToast("ເກີດຂໍ້ຜິດພາດ ຕໍ່ຕັ້ງຄ່າສຽງ", { appearance: 'error', autoDismiss: true })
        }
    }

    const initSetting = async () => {
        // if (!isLoadSetting) {
        const SHOP_ID = await localStorage.getItem("SHOP");
        await getSettings({
            variables: {
                where: {
                    shop: SHOP_ID,
                },
                orderBy: "createdAt_ASC"
            }
        })
        // setIsLoadSetting(true)
        // }
    }

    const fetchLive = async () => {
        const liveId = match.params?.liveId;
        await getLive({
            variables: {
                where: {
                    id: liveId
                }
            }
        });
    }

    const endLive = async () => {
        try {
            const access_token = location.state?.access_token
            const fbLiveId = location.state?.fbLiveId;

            // setLoading(true)
            if (endLiveLoading) return;
            await endLiveVDO({
                variables: {
                    id: liveData?.live?.id,
                    fbLiveId: liveData?.live?.fbLiveId || fbLiveId,
                    page_access_token: liveData?.live?.pageAccessToken || access_token
                }
            })

            await unsubscribeLive({
                variables: {
                    id: liveData?.live?.id,
                    fbLiveId: liveData?.live?.fbLiveId || fbLiveId,
                    page_access_token: liveData?.live?.pageAccessToken || access_token
                }
            })
            addToast("ສິ້ນສຸດການໄລຟນີ້ແລ້ວ!", {
                appearance: 'success',
                autoDismiss: true,
            })
            // setLoading(false)
            history.push(`/live-manage/history/limit/30/page/1`)
            // history.push(`/live-detail`, { liveData });
        } catch (err) {
            // setLoading(false)
            // history.push(`/live-manage/history/limit/30/page/1`)
            console.log('error:', err)
        }
    }

    const tabs = [
        { title: 'ອໍເດີ້', content: <OrderLiveScreen restoreAmountAndCancelOrder={restoreAmountAndCancelOrder} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} orders={orders} totalOrder={totalOrder} liveData={liveData} loadingOrders={loadingOrders} /> },
        { title: 'ສິນຄ້າ', content: <StockLiveScreen fetchLiveStocks={fetchLiveStocks} liveStocks={liveStocks} setLiveStocks={setLiveStocks} totalLiveStock={totalLiveStock} liveData={liveData} seTotalLiveStock={seTotalLiveStock} /> },
        { title: 'ຄອມແມ້ນ', content: <CommentLiveScreen endLiveLoading={endLiveLoading} onPlayNoProduct={onPlayNoProduct} endLive={endLive} liveData={liveData} playNoProduct={playNoProduct} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveStocks={liveStocks} updateOrder={updateOrder} updateLiveStock={updateLiveStock} /> }
        // TODO for create order v2
        // { title: 'ຄອມແມ້ນ', content: <CommentLiveScreen endLiveLoading={endLiveLoading} onPlayNoProduct={onPlayNoProduct} endLive={endLive} liveData={liveData} playNoProduct={playNoProduct} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveStocks={liveStocks} updateOrders={updateOrderV2} /> }
    ];

    return (
        // width > 700 ?
        width > 700 ?
            <div>
                <div className="mt-4" style={{ margin: "10px 0px", display: 'flex', alignItems: 'center' }}>
                    <img
                        className="d-block"
                        src={"/images/live.gif"}
                        alt="Second slide"
                        style={{ width: 28 }}
                    />
                    <div onClick={() => history.goBack()} style={{ fontWeight: 'bold', cursor: 'pointer', color: COLOR_APP, fontSize: 20, }}>ຈັດການໄລຟ </div>
                    <FontAwesomeIcon icon={faAngleRight} className="mr-2 ml-2" />
                    <div style={{ fontWeight: 'bold', fontSize: 20 }}> Live Now</div>
                </div>
                {/* <Breadcrumb style={{ marginLeft: 10, marginRight: 10, width: "100%", marginTop: 20, padding: 0 }}>
                <Breadcrumb.Item onClick={() => history.goBack()}>ຈັດການໄລຟ</Breadcrumb.Item>
                <Breadcrumb.Item active>ໜ້າ Live Screen</Breadcrumb.Item>
            </Breadcrumb> */}
                <div className="row pl-2">
                    {/* end of liveScreen in window mode */}
                    {/* <TabletLiveScreen /> */}
                    <div className="col-5" style={{ padding: "0px 2px" }}><OrderLiveScreen restoreAmountAndCancelOrder={restoreAmountAndCancelOrder} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} orders={orders} totalOrder={totalOrder} liveData={liveData} loadingOrders={loadingOrders} /></div>
                    <div className="col-4" style={{ padding: "0px 2px" }}><StockLiveScreen fetchLiveStocks={fetchLiveStocks} liveStocks={liveStocks} setLiveStocks={setLiveStocks} totalLiveStock={totalLiveStock} liveData={liveData} seTotalLiveStock={seTotalLiveStock} /></div>
                    <div className="col-3" style={{ padding: "0px 2px" }}><CommentLiveScreen endLiveLoading={endLiveLoading} onPlayNoProduct={onPlayNoProduct} endLive={endLive} liveData={liveData} playNoProduct={playNoProduct} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveStocks={liveStocks} updateOrder={updateOrder} updateLiveStock={updateLiveStock} /></div>
                    {/* //TODO For create order v2 */}
                    {/* <div className="col-3" style={{ padding: "0px 2px" }}><CommentLiveScreen endLiveLoading={endLiveLoading} onPlayNoProduct={onPlayNoProduct} endLive={endLive} liveData={liveData} playNoProduct={playNoProduct} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveStocks={liveStocks} updateOrders={updateOrderV2} /></div> */}
                </div>
            </div> :
            <div style={{ marginTop: 52 }}>
                <div style={{ margin: "10px 0px", display: 'flex', alignItems: 'center' }}>
                    <img
                        className="d-block"
                        src={"/images/live.gif"}
                        alt="Second slide"
                        style={{ width: 28 }}
                    />
                    <div style={{ color: COLOR_APP, fontWeight: 'bold' }}> Live Now</div>
                </div>
                <div style={{ background: "#FFF", borderRadius: 6, margin: 2, padding: 5, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ margin: "10px 2px", padding: "6px 4px", fontSize: 16, fontWeight: 'bold', background: "#F5F5FA", borderRadius: 8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}>ຫົວຂໍ້ໄລຟ: {liveData?.live?.description}</div>
                    {/* <div style={{ border: '2px solid #F5F5FA', borderRadius: 10 }}> */}
                    {/* {liveData?.live?.videoLink &&
                        <div style={{
                            border: '2px solid #F5F5FA',
                            borderRadius: 10,
                            // paddingBottom: '56.25%', // 16:9 aspect ratio
                            height: 150,
                            maxWidth: '100%'
                        }}>
                            <FacebookProvider appId="694959341044795">
                                <EmbeddedVideo
                                    href={liveData?.live?.videoLink ?? ''}
                                    // href={"https://facebook.com/105707065790090/videos/161398103448312"}
                                    // width="50"
                                    height={146}
                                    showText={false}
                                    style={{
                                        display: 'block',
                                        maxWidth: '90%'
                                    }}
                                />
                            </FacebookProvider>
                        </div>
                        // <FacebookVideo videoId="161398103448312" aspectRatio={16 / 9} />

                    } */}
                    {/* </div> */}
                    {/* <div className="video-container">
                        <FacebookProvider appId="694959341044795">
                            <EmbeddedVideo href={"https://facebook.com/105707065790090/videos/161398103448312"} />
                        </FacebookProvider>
                    </div> */}

                    <div style={{ display: 'flex', margin: '10px 0px', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FontAwesomeIcon className="mr-2" color={COLOR_APP} icon={playNoProduct ? faVolumeHigh : faVolumeMute} />
                                ປິດ/ເປີດສຽງ
                            </div>
                            <div>
                                <Switch
                                    checked={playNoProduct}
                                    onChange={() => onPlayNoProduct()}
                                    onColor="#bfbdc7"
                                    onHandleColor="#422f90"
                                    handleDiameter={25}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={15}
                                    width={40}
                                    className="react-switch"
                                    id="material-switch"
                                />
                            </div>
                        </div>

                        <div>
                            <Button className="btn btn-danger" style={{ borderRadius: 10, padding: '5px 10px' }}
                                onClick={() => endLive()}
                            >
                                {endLiveLoading ? <Spinner size="sm" animation="border" /> : <FontAwesomeIcon icon={faVideoSlash} />}
                                ສິ້ນສຸດໄລຟ
                            </Button>
                        </div>
                    </div>
                </div>
                {/* <div style={{ display: 'flex', justifyContent: 'center', margin: 5 }}>
                    <div style={{ width: width / 2.5, height: 70, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', alignSelf: 'center', border: '1px solid #F5F5FA', boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", borderRadius: 10, fontSize: 20, fontWeight: 'bold', padding: 10, margin: "0px 10px 10px 10px" }}>
                        <div>ອໍເດີ້ເຂົ້າ</div>
                        <div style={{ color: COLOR_APP, fontSize: 23 }}>{thousandSeperate(totalOrder)}</div>
                    </div>
                    <div style={{ width: width / 2.5, height: 70, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', alignSelf: 'center', border: '1px solid #F5F5FA', boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", borderRadius: 10, fontSize: 20, fontWeight: 'bold', padding: 10, margin: "0px 10px 10px 10px" }}>
                        <div>ສິນຄ້າທັງຫມົດ</div>
                        <div style={{ color: COLOR_APP, fontSize: 23 }}>{thousandSeperate(totalLiveStock)}</div>
                    </div>
                </div> */}
                <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
                    {tabs.map((tab, index) => (
                        <div
                            key={index}
                            onClick={() => setActiveTab(index)}
                            className={activeTab === index ? 'active' : ''}
                            style={{ background: activeTab === index ? '#F5F5FA' : '', color: activeTab === index ? COLOR_APP : '', border: activeTab === index ? COLOR_APP : '', fontSize: 20, padding: "3px 20px" }}
                        >
                            {tab.title}
                        </div>
                    ))}
                </div>
                <div>
                    {tabs.map((tab, index) => (
                        <div key={index} style={{ display: activeTab === index ? 'block' : 'none' }}>
                            <div>{tab.content}</div>
                        </div>
                    ))}
                </div>
            </div>
        //  :
        // <div style={{ padding: 10 }}>
        //     {/* liveScreen on mobile mode */}
        //     <MobileLiveScreen />
        // </div>
    );
}

export default LiveScreen;
